import logo from '../assets/logo.png';
import email from '../assets/email.png';
import mobile from '../assets/mobile.png';

export default {
  logo,
  email,
  mobile,
};
